(function ($, Drupal, drupalSettings, once) {
  Drupal.behaviors.header = {
    attach: function (context, settings) {
      once("header", ".main-header", context).forEach(function (element) {
        var lastScrollTop = 0;

        $(window).on("scroll load", function (e) {
          if ($(window).scrollTop() > 60) {
            $(".main-header").addClass("scrolled");
          } else {
            $(".main-header").removeClass("scrolled");
          }

          var st = $(this).scrollTop();
          if (st > lastScrollTop) {
            $(".main-header").removeClass("scrollUp").addClass("scrollDown");
          } else {
            $(".main-header").removeClass("scrollDown").addClass("scrollUp");
          }
          lastScrollTop = st;
        });
        $(".toggle-search").click(function (e) {
          e.preventDefault();
          e.stopPropagation();
          $(".search-block").toggleClass("open");
        });
        $(".search-block").click(function (e) {
          e.stopPropagation();
        });
        $(document).click(function () {
          $(".search-block").removeClass("open");
        });
      });

      once("menu", ".main-header__nav", context).forEach(function () {
        $(document).on("click", ".toggle-menu", function (e) {
          e.preventDefault();

          $(this).toggleClass("open");
          $("body").toggleClass("menu-open");
        });

        $(".menu-wrapper").each(function () {
          var el = $(this).find("a, span");
          var elActive = $(this).find("a.is-active");

          elActive.parent("li").addClass("active");
          elActive.parent("li").parents("li").addClass("active-trail");

          if ($(this).children("ul").find("ul").length) {
            $(this).children("ul").addClass("sublvl");
          }

          el.each(function () {
            if ($(this).next("ul").length) {
              $(this).after('<i class="expand"></i>');
            }
          });
        });

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          deviceEventType = "touchstart";
        } else {
          deviceEventType = "click";
        }

        $(document).on(deviceEventType, ".menu-wrapper .expand", function () {
          $(this).parent("li").toggleClass("open");
        });

        $(document).on(deviceEventType, ".menu-wrapper span", function () {
          $(this).parent("li").toggleClass("open");
        });

        $(".menu-wrapper > ul > li").each(function () {
          $(this).on("mouseenter", function () {
            $(".menu-wrapper > ul > li").removeClass("hovered");
            $(this).addClass("hovered");
          });
        });

        $(".main-header").on("mouseleave", function () {
          $(".menu-wrapper > ul > li").removeClass("hovered");
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings, once);
